// eslint-disable-next-line
import DeviceData from 'drivers/deviceData';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import { getLocaleCode } from 'utils/i18n';

/**
 * Reads the saved language list and currently selected language ID from storage.
 * @returns {{ languages: Array, selectedLanguageId: number|null }}
 */
export function loadLanguagesFromStorage() {
  const languages = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGE) || [];
  const selectedLanguageId = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGEID);
  return { languages, selectedLanguageId };
}

/**
 * Persists the selected language to storage and triggers a language change on the device.
 * @param {number} languageId
 * @param {Array<{ id: number, language_code: string }>} languages
 * @returns {string|null} The matched raw language_code, or null if not found.
 */
export function persistLocale(languageId, languages) {
  Storages.MainStorage.setItem(StorageKeys.Keys.LANGUAGEID, languageId);

  const match = languages.find((l) => l.id === languageId);
  if (match) {
    const extractedLanCode = getLocaleCode(match.language_code);
    Storages.MainStorage.setItem(StorageKeys.Keys.LANGUAGECODE, extractedLanCode);
  }

  DeviceData.changeLanguage();
  return match ? match.language_code : null;
}
